import * as React from 'react';
import styled from 'styled-components';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import { devices } from '../../styles/theme/devices';
import { Box } from '@material-ui/core';

// https://github.com/styled-components/styled-components/issues/439
const avoidedProps = ['device', 'invert'];
export const Hidden = styled((props) => <Box {...omit(props, avoidedProps)} />)`
  ${(props) => {
    const { invert, device } = pick(props, avoidedProps);
    const opposites = {
      none: 'initial',
      initial: 'none',
    };
    const display = invert ? 'initial' : 'none';

    return `
      display: ${display};
      @media screen and ${devices[device]} {
        display: ${opposites[display]};
      }`;
  }}
`;
